import React from "react";
import "./Login.scss";
import { isValidEmail } from "../../UserManagement/AddNewUserModal/AddNewUserModal";
import { withRouter } from "react-router";
import { gql } from "@apollo/client";
import { checkLogin, deleteLogin, deleteTokens } from "../../../auth";

import { apolloClient } from "../../../index";
import { getTokens, saveTokens, saveLogin } from "../../../auth";
import { notify } from "../../../components/Notify/Notify";

export default withRouter(
  class Login extends React.Component {
    state = {
      email: "",
      password: "",
      rememberMe: false,
      isPasswordShown: false,
      showPasswordUpdateMessage: false,
    };

    componentDidMount() {
      if (checkLogin("login")) {
        this.props.history.push("/login");
        deleteTokens();
        deleteLogin("login");
        const title = "Success";
        const detail = "User Logged out successfully!";
        const type = "success";
        notify(title, detail, type);
      }
    }

    hasValidValues = () => {
      return (
        this.state.email.trim().length > 0 &&
        isValidEmail(this.state.email.trim()) &&
        this.state.password.length > 0
      );
    };

    onChangeValue = (event) => {
      this.setState({
        [event.target.name]: event.target.value,
      });
    };

    loginHandler = (e) => {
      e.preventDefault();

      const variables = {
        username: this.state.email,
        password: this.state.password,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation Login($username: String!, $password: String!) {
              tokenAuth(username: $username, password: $password) {
                token
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.tokenAuth.token) {
            saveTokens({
              JWT: result.data.tokenAuth.token,
            });
          }
        })
        .then(() => {
          apolloClient
          .query({
            query: gql`
            query updatedPasswordBeforeDays($email: String!) {
              updatedPasswordBeforeDays(email: $email)
            }
            `,
            variables: {
              email: this.state.email,
            },
          })
          .then((result) => {
            if(result.data.updatedPasswordBeforeDays <90){
                const tokens = getTokens();
                if (tokens && tokens.JWT) {
                  // Delete locally stored email and password from user's browsers
                  // TODO: We can most likely remove this code after it has been in Prod for a while
                  if (checkLogin("email")) {
                    deleteLogin("email");
                  }
                  if (checkLogin("password")) {
                    deleteLogin("password");
                  }
                  saveLogin("login", false);
                  window.location.href = "/";
            }   
            }
            else{
                this.setState({
                  showPasswordUpdateMessage : true
                })
            }      
          })
          .catch(() => {});    
        })
        .catch((e) => {
          //alert message on wrong credentials
          var title = "Error";
          var detail = "There are no active users with these credentials.";
          var type = "error";

          //if aws is down or server error occurs, alert message to contact support
          if (e.message === 'Load failed') {
            title = 'Error';
            detail =
              'Unexpected error occured. Please contact Tikler support for help';
            type = 'error';
          }

          notify(title, detail, type);
        });
    };

    signUpHandler = () => {
      this.props.history.push("/sign-up");
    };

    forgotPasswordHandler = () => {
      this.props.history.push("/forgot-password");
    };

    togglePasswordVisiblity = () => {
      const { isPasswordShown } = this.state;
      this.setState({ isPasswordShown: !isPasswordShown });
    };

    render() {
      const { isPasswordShown } = this.state;
      return (
        <div className="login-container">
          <h3 className="title">Login</h3>

          <form>
            <div className="form-groups">
              <div className="form-group">
                <label>Email Address*</label>
                <input
                  type="email"
                  name="email"
                  maxLength="50"
                  value={this.state.email}
                  onChange={this.onChangeValue}
                  className={`form-control email ${
                    this.state.email && !isValidEmail(this.state.email)
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="Email Address"
                />

                {this.state.email && !isValidEmail(this.state.email) ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : null}
              </div>

              <div className="form-group" id='passwordid'>
                <label>Password*</label>
                <input
                  type={isPasswordShown ? "text" : "password"}
                  name="password"
                  maxLength="50"
                  value={this.state.password}
                  className="form-control password"
                  onChange={this.onChangeValue}
                  placeholder="Password"
                />
                <i
                    className={`fa ${isPasswordShown ? "fa-eye-slash" : "fa-eye"} password-icon`}
                    onClick={this.togglePasswordVisiblity}
                  />

                {this.state.showPasswordUpdateMessage ? (
                  <label className="error">
                    Heads up, your password has expired. <a href="https://app.tikler.io/reset-password" className="text-decoration-ul" style={{"color":"red","textDecoration":"underline"}}> Reset password now.</a> 
                  </label>
                ) : null}
              </div>         
              <div className="form-group-footer">
                {/* <div className="remember-me-form-group">
                  <input
                    type="checkbox"
                    id="remember-me"
                    checked={this.state.rememberMe}
                    onChange={(e) =>
                      this.setState({ rememberMe: e.target.checked })
                    }
                  />
                  <label htmlFor="remember-me">Remember me</label>
                </div> */}
                <span
                  className="forgot-password"
                  onClick={this.forgotPasswordHandler}
                >
                  Forgot Password?
                </span>
              </div>
            </div>

            <button
              className="btn-primary login-button"
              disabled={!this.hasValidValues()}
              onClick={this.loginHandler}
              type="submit"
            >
              Login
            </button>
          </form>

          <p className="sign-up-options">
            Don’t have an account?{" "}
            <span className="sign-up" onClick={this.signUpHandler}>
              Sign Up
            </span>
          </p>
        </div>
      );
    }
  }
);
